import axios from 'axios'
// import store from 'store'
import { notification } from 'antd'
import { firebaseAuth } from 'services/firebase'

const { REACT_APP_API_URL } = process.env

const apiClient = axios.create({
  baseURL: `${REACT_APP_API_URL}`,
  // timeout: 1000,
  // headers: { 'X-Custom-Header': 'foobar' }
})

apiClient.interceptors.request.use(async request => {
  if (firebaseAuth.currentUser === null) {
    return request
  }
  let accessToken = null
  accessToken = await firebaseAuth.currentUser
    .getIdToken(/* forceRefresh */ true)
    .then(idToken => {
      return idToken
    })
    .catch(err => {
      return err
    })
  request.headers.Authorization = `Authorization ${accessToken}`

  return request
})

apiClient.interceptors.response.use(
  res => res,
  error => {
    // Error handling
    const { response } = error
    if (!response) {
      notification.error({
        message: 'Error!',
        description:
          'An error occured while sending your request. Please check your internet connection',
      })
      return response
    }
    const { message, errors } = response.data

    if (response.status === 422) {
      let fields = []
      if (errors && Array.isArray(errors)) {
        fields = errors.map(errorItem => {
          return { name: errorItem.name, errors: [errorItem.message] }
        })
      }
      response.errorFields = fields

      notification.error({
        message: 'Failed!',
        description: 'Input validation failed',
      })
      return response
    }
    if (message) {
      return notification.error({
        message: 'Failed!',
        description: message,
      })
    }
    return notification.warning({
      message: 'An error occured while signing you in. Please check your internet connection',
    })
  },
)

export default apiClient
